import { KTSVG } from "../../../../_metronic/helpers"
import { Link } from "react-router-dom"


/**
 * Disclaimer
 * Renders a safety disclaimer card for address verification.
 */
export const Disclaimer = () => {
    return <div
        className="card min-h-42px mt-3 w-100 rounded-2"
        style={{ backgroundColor: "#FBF6F7", border: "1px solid #d4d4d4", cursor: "pointer" }}
    >
        <div className="card-body p-1 px-4 d-flex justify-content-between align-items-center">
            <div className="text-start d-flex align-items-center">
                <div className="d-flex align-items-center gap-4">
                    <i style={{ color: "#ED1C24" }} class="bi fs-2 bi-exclamation-triangle-fill"></i>
                    <div className="fw-semibold fs-2" style={{ color: "#ED1C24" }}>Safety Disclaimer</div>
                </div>
            </div>
            <div className='pt-1'>
                <i style={{ color: "#ED1C24" }} class="bi fs-2 bi-arrow-right-circle-fill"></i>
            </div>
        </div>
    </div>
}

/**
 * Attention
 * Renders a warning notice requiring user attention for address verification.
 */
export const Attention = ({ data }) => {
    return <div className="notice d-flex bg-light-warning rounded border-warning border border-dashed p-2">
        <div className="d-flex flex-column">
            <div className="d-flex border-1 border-warning border-bottom-dashed align-items-center">
                <KTSVG path='/media/icons/duotune/general/gen044.svg' className='svg-icon-2x svg-icon-warning me-2' />
                <h5 className="text-gray-900 pt-3 fw-semibold ">We need your attention!</h5>
            </div>
            <div className=" mb-md-0 fw-semibold">

                <div className="fs-7 p-2 text-gray-800">{data ? data : "Verify your address to ensure accurate delivery. If address is correct, proceed further If not, update your address"}</div>
            </div>
        </div>

    </div>
}

/**
 * AddressDetailCard
 * Displays detailed address information in a card format.
 */
export const AddressDetailCard = ({ addressData }) => {

    return (
        <div style={{ border: '1px solid #eaeaea' }} className="card shadow-sm mt-3">
            <div className="card-header ps-5 py-0  pe-0 flex justify-content-between align-items-center" style={{ minHeight: '0px', backgroundColor: "#000" }}>
                <div className="card-title fw-semibold fs-5 d-flex align-items-center text-white">
                    <i className="bi bi-geo-alt-fill text-white me-1 mb-1 fs-4"></i>
                    Delivery Address
                </div>
            </div>

            <div className="card-body p-4">
                <div className="fw-semibold fs-6 text-break">
                    <div className="mb-2 d-flex">
                        <span className=" me-2">Name:</span>
                        <span className="text-gray-600">
                            {(addressData.first_name && addressData.last_name)
                                ? `${addressData.first_name} ${addressData.last_name}`
                                : "--"}
                        </span>

                    </div>
                    <div className="mb-2 d-flex">
                        <span className=" me-2">House/Shop No:</span>
                        <span className="text-gray-600 ">{addressData.address1 || "--"}</span>
                    </div>
                    <div className="mb-2 d-flex">
                        <span className=" me-2">Sector/Village:</span>
                        <span className="text-gray-600 ">{addressData.address2 || "--"}</span>
                    </div>
                    <div className="mb-2 d-flex">
                        <span className=" me-2">Area:</span>
                        <span className="text-gray-600 ">{addressData.address3 || "--"}</span>
                    </div>
                    <div className="mb-2 d-flex">
                        <span className=" me-2">Landmark:</span>
                        <span className="text-gray-600 ">{addressData.landmark || "--"}</span>
                    </div>
                    <div className="mb-2 d-flex">
                        <span className=" me-2">City:</span>
                        <span className="text-gray-600 ">{addressData.city || "--"}</span>
                        <span className="ms-3 me-2">District:</span>
                        <span className="text-gray-600 ">{addressData.district || "--"}</span>

                    </div>
                    <div className="mb-2 d-flex">
                        <span className="  me-2">State:</span>
                        <span className="text-gray-600 ">{addressData.state || "--"}</span>
                        <span className="ms-3 me-2">Pincode:</span>
                        <span className="text-gray-600 ">{addressData.pincode || "--"}</span>

                    </div>
                </div>
            </div>


        </div >
    )
}

export const UserCard = ({ addressData }) => {

    return (
        <div style={{ border: '1px solid #eaeaea' }} className="card shadow-sm rounded-3">
            <div className="card-header ps-5 py-0  pe-0 flex justify-content-between align-items-center" style={{ minHeight: '0px', backgroundColor: "#000" }}>
                <div className="card-title fw-semibold fs-5 d-flex align-items-center text-white">
                    <i className="bi bi-person-fill fs-2 me-2 text-white"></i>
                    User Info
                </div>
            </div>
            <div className="card-body px-4 py-3">
                <div className="d-flex justify-content-between">
                    <div className="mb-2 d-flex align-items-center">
                        <i className="bi bi-person-fill text-dark fs-5 me-2"></i>
                        <span className="fw-semibold fs-6">{addressData.first_name} {addressData.last_name}</span>
                    </div>
                    <div className="mb-2 d-flex align-items-center">
                        <i className="bi bi-phone-fill text-dark fs-5 me-2"></i>
                        <span className="fw-semibold fs-6 me-2">{addressData.phone ? addressData.phone : "N/A"}</span>
                        <span className="badge badge-light-success  ms-2">Verified</span>
                    </div>
                </div>

                <div className=" d-flex align-items-center">
                    <i className="bi bi-envelope-fill text-dark fs-5 me-2"></i>
                    <span className="fw-semibold fs-6 me-2">{addressData.email ? addressData.email : "test@gmail.com"}</span>
                    <span className="badge  badge-light-danger  ms-2">Not Verified</span>
                </div>
            </div>
        </div>
    )
}

export const ButtonDiv = ({ btn1, btn2 }) => {
    return <div className="d-flex w-100 align-items-center justify-content-center gap-4">
        <Link to={btn1?.url} className={btn1?.class}> {btn1?.label} </Link>
        <Link to={btn2?.url} className={btn2?.class}> {btn2?.label} </Link>
    </div>

}
export const OrderDetail = ({ orders }) => {
    return <div className="card card-flush shadow-sm border-0 rounded-1 overflow-hidden mt-3">
        <div
            style={{ minHeight: '40px' }}
            className="card-header bg-dark text-white py-3 px-4"
            id="kt_chat_contacts_header"
        >
            <div className="d-flex justify-content-between align-items-center">
                <div className="fw-semibold fs-6">
                    Redemption ID: <span className="">{orders?.order_id}</span>
                </div>
            </div>
        </div>

        <div className="card-body px-3 py-2" id="kt_chat_contacts_body">
            <div
                className="scroll-y pe-2"
                style={{ maxHeight: '120px', overflowY: 'auto' }}
                data-kt-scroll="true"
                data-kt-scroll-activate="{default: false, lg: true}"
                data-kt-scroll-dependencies="#kt_header, #kt_toolbar, #kt_footer, #kt_chat_contacts_header"
                data-kt-scroll-wrappers="#kt_content, #kt_chat_contacts_body"
                data-kt-scroll-offset="0px"
            >
                {orders?.items?.map((item, index) => (
                    <div key={index} className="">
                        <div className="d-flex justify-content-between align-items-start">
                            <div className="flex-grow-1 d-flex justify-content-between">
                                <div className="f text-dark fs-6 fw-semibold">{item?.sku_name}</div>
                                <div className="text-muted fs-6 fw-semibold">
                                    Qty: <span className="fw-semibold">{item?.qty}1</span>
                                </div>
                            </div>
                        </div>
                        {index < orders.items.length - 1 && (
                            <div className="separator separator-dashed my-2"></div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    </div>

}

